<template>
    <Head title="Recuperar Senha" />
    <div class="min-h-screen grid grid-cols-1 md:grid-cols-2">
      <div class="flex items-center justify-center bg-white rounded-t-lg md:rounded-none md:rounded-l-lg min-h-full border-r-2">
        <form class="mt-1 w-full max-w-lg" @submit.prevent="login">
          <img src="/images/allumer_logo.png">
          <div class="py-12 px-10 md:px-0">
            <h1 class="text-left text-3xl font-bold text-black_light font-roboto">Recuperar Senha</h1>
            <h1 class="text-left text-black_light text-xs font-roboto-light pt-3">Será enviado um código de recuperação para o e-mail cadastrado.</h1>
            <div class="mt-6 mx-auto w-100 border-b-2" />
            <text-input v-model="form.email" :error="form.errors.email" class="mt-10" label="Email" type="email" autofocus autocapitalize="off" />
            <div class="flex items-center justify-center">
              <loading-button :loading="form.processing" class="btn-purple w-80 mt-6 justify-center" type="submit">Enviar</loading-button>
            </div>
          </div>
        </form>
      </div>
      <div class="min-h-screen flex items-center justify-center 
    bg-center bg-no-repeat login-background">
    </div>
    </div>
  </template>
  
  <script>
  import { Head } from '@inertiajs/inertia-vue3'
  import Logo from '@/Shared/Logo'
  import TextInput from '@/Shared/TextInput'
  import LoadingButton from '@/Shared/LoadingButton'
  
  export default {
    components: {
      Head,
      LoadingButton,
      Logo,
      TextInput,
    },
    data() {
      return {
        form: this.$inertia.form({
          email: 'admin@hawk.com.br',
          password: '123456',
          remember: false,
        }),
      }
    },
    methods: {
      login() {
        this.form.post('/login')
      },
    },
  }
  </script>
  